import { scrollToBlock } from '@fttb/common/utils';
import { resetStore as resetCheckAddressStore } from "../../checkAddress/actions";
import { resetColoredTariffsData } from "./actions";
import { getNotificationAnchorId } from "./selectors";
import { backToCheckAddressStep } from "../addressVerification/slice";
export var resetAddressAndScrollInto = function resetAddressAndScrollInto() {
  return function (dispatch, getState) {
    var anchorId = getNotificationAnchorId(getState());
    if (anchorId) scrollToBlock(anchorId);
    dispatch(resetColoredTariffsData());
    dispatch(resetCheckAddressStore());
    dispatch(backToCheckAddressStep());
  };
};